import actionTypes from '../actionTypes';

export function requestTournamentGameUrl(game, user, isVirtual) {
  return {
    type: actionTypes.TOURNAMENT_GAME_URL_REQUEST,
    value: { game, user, isVirtual },
  };
};

export function successTournamentGameUrl(id, url, size) {
  return {
    type: actionTypes.TOURNAMENT_GAME_URL_SUCCESS,
    value: { id, url, size },
  };
};

export function failTournamentGameUrl(id, e) {
  return {
    type: actionTypes.TOURNAMENT_GAME_URL_FAIL,
    id: id,
    exception: e,
    message: e.response.data.err.message
  };
};